/**
 * Заглавные страницы разделов.
 * "62:3655" = SberBusiness.
 * "33:181" = Sber Api.
 */
export const channelMainPageFigmaIds = ["62:3655", "33:181"];
